import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useActiveBirthdayRollingPaperId } from '../../../hooks/useActiveBirthdayRollingPaperId';
import Card from '../../../components/ui/Card';
import Button from '../../../components/ui/Button';

const StudentBirthdayRollingPaper: React.FC = () => {
  const navigate = useNavigate();
  const paperId = useActiveBirthdayRollingPaperId();

  const openPaper = () => {
    if (!paperId) return;
    navigate(`/class/public/birthday-rolling-paper/${paperId}`);
  };

  return (
    <div
      style={{
        padding: 'var(--gap-level-4)',
        maxWidth: 560,
        margin: '0 auto',
        fontFamily: 'var(--font-family-primary)',
      }}
    >
      <h1
        style={{
          margin: '0 0 var(--gap-level-4) 0',
          fontSize: '22px',
          fontWeight: 600,
          color: 'var(--Color-text-strong)',
        }}
      >
        생일 롤링페이퍼
      </h1>

      {paperId ? (
        <Card padding="24px" borderRadius="16px" background="var(--Color-background-normal)">
          <p style={{ margin: '0 0 16px 0', fontSize: '15px', lineHeight: 1.6, color: 'var(--Color-text-normal)' }}>
            담임 선생님이 생일 축하 롤링페이퍼를 열었습니다. 친구들이 남긴 메시지를 확인하고, 직접 한마디를 남길 수도 있습니다.
          </p>
          <Button variant="primary" size="medium" onClick={openPaper}>
            롤링페이퍼 열기
          </Button>
        </Card>
      ) : (
        <Card padding="24px" borderRadius="16px" background="var(--Color-background-normal)">
          <p style={{ margin: '0 0 16px 0', fontSize: '15px', lineHeight: 1.6, color: 'var(--Color-text-normal)' }}>
            아직 열려 있는 생일 롤링페이퍼가 없습니다. 담임 선생님이 생일 관리에서 링크를 만들면 여기서 바로 들어갈 수 있어요.
          </p>
          <Button variant="line" size="medium" onClick={() => navigate('/class/student')}>
            홈으로
          </Button>
        </Card>
      )}
    </div>
  );
};

export default StudentBirthdayRollingPaper;
